goog.provide("shadow.js.shim.module$src$svg$wpp$content$location_svg$default");
shadow.js.shim.module$src$svg$wpp$content$location_svg$default = shadow.js.shim.module$src$svg$wpp$content$location_svg.default;
